export default class Exchange {
    constructor(message, myBooksIds, othersBooksIds, expiration) {
        this.message = message
        this.myBooksIds = myBooksIds
        this.othersBooksIds = othersBooksIds
        this.expiration = expiration
    }
}